import React, { useState } from "react";

const ERROR_IMG_SRC =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg==";

type ImageWithFallbackProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  /**
   * Use for above-the-fold images (e.g. hero banners). Switches to eager
   * loading + high fetch priority + synchronous decoding so the LCP element
   * isn't deferred. Off-by-default keeps the rest of the page lazy.
   */
  priority?: boolean;
};

export const ImageWithFallback = (props: ImageWithFallbackProps) => {
  const [didError, setDidError] = useState(false);
  const {
    src,
    alt,
    style,
    className,
    priority,
    loading,
    decoding,
    fetchPriority,
    ...rest
  } = props;

  const resolvedLoading = loading ?? (priority ? "eager" : "lazy");
  const resolvedDecoding = decoding ?? (priority ? "sync" : "async");
  const resolvedFetchPriority =
    fetchPriority ?? (priority ? "high" : undefined);

  if (didError) {
    return (
      <div
        className={`inline-block bg-gray-100 text-center align-middle ${className ?? ""}`}
        style={style}
      >
        <div className="flex h-full w-full items-center justify-center">
          <img
            src={ERROR_IMG_SRC}
            alt="Error loading image"
            {...rest}
            data-original-url={src}
          />
        </div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      loading={resolvedLoading}
      decoding={resolvedDecoding}
      fetchPriority={resolvedFetchPriority}
      {...rest}
      onError={() => setDidError(true)}
    />
  );
};
